import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'pcm-data-modal-partial-success',
	templateUrl: './data-modal-partial-success.component.html',
	styleUrls: [
		'../data-modal/data-modal.component.scss',
		'./data-modal-partial-success.component.scss'
	]
})

export class DataModalPartialSuccessComponent implements OnInit {

	@Input() showSuccess = '';
	@Input() successText = '';
	@Input() errorText = '';
	@Input() successDataObj = '';
	@Input() errorDataObj = '';
	@Input() title = '';

	@Output() formCancel: EventEmitter<any> = new EventEmitter();

	columnsConfigError = [];
	columnsConfigSuccess = [];

	constructor(
		public configService: ConfigService
	) { }

	ngOnInit() {
		this.columnsConfigError = this.configService.getTableFields(this.errorDataObj, true);
		this.columnsConfigSuccess = this.configService.getTableFields(this.successDataObj, true);

		console.log('DATA MODAL PARTIAL SUCCESS INIT', this.showSuccess, this.successText, this.errorText, this.successDataObj, this.errorDataObj);
	}

	pageFormCancel(event) {
		this.formCancel.emit(event);
	}
}
